// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "" + {"16":"32423a519527da1bbc28","945":"3f119729fca7013886b3"}[chunkId] + ".js";
};